export const GET_RELATIONSHIPS = 'organisation/GET_RELATIONSHIPS'
export const SET_RELATIONSHIPS = 'organisation/SET_RELATIONSHIPS'
export const GET_ORGANISATION_OPTIONS = 'organisation/GET_ORGANISATION_OPTIONS'
